'use strict';

import register from './core';
import '../functions/jquery-global.js';
import { trackLink } from '../functions/common';

register('link-list-tracking', function (element) {
  let $el = $(element),
    $link = $el.find('.link-list__item a');

  $link.on('click', function (e) {
    var label = $(this).attr('aria-label');
    trackLink('sz', 'CTA', 'Click', label);
  });
});
